import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const redirectMap: Record<string, string> = {
  "/wallet": "/profile/payments",
  "/lobby": "/lobby/slots?all=true",
};

const Redirector = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const url = searchParams.get("url");

  useEffect(() => {
    if (url && redirectMap[url]) {
      navigate(redirectMap[url], { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [url, navigate]);

  return null;
};

export default Redirector;
